import React from 'react';

export default function clearRenderer () {
	return (
		<span
			className="Select-clear"
			dangerouslySetInnerHTML={{ __html: '&times;' }}
		/>
	);
};



// WEBPACK FOOTER //
// ./src/component/select/utils/defaultClearRenderer.js